import {
  recordLandingActivity,
  recordSignupActivity,
} from "@faire/deprecated-retailer-visitor-shared/actions/user/recordLoggedOutActivity";
import { useRecordMilestoneOnce } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { useSearchPageExactSearchReturnedNoResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageExactSearchReturnedNoResults";
import { useSearchPageQueryIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageRequestId } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageFilters } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { trackSearchNarrowSearchEmptyAndResultsWithEmptyOrResultsView } from "@faire/web-api--source/events/search/view/narrowSearchEmptyAndResultsWithEmptyOrResults";
import { HAS_VISITED_CATEGORY_SEARCH_PAGES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_VISITED_CATEGORY_SEARCH_PAGES";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

const CATEGORY_FILTER_PREFIX: string = "category:";
const C2_NUM_CATEGORIES: number = 2;
const CATEGORY_PIPE: string = "|";
const NUM_FILTERS_FOR_TRACKING: number = 1;

export const useSearchPageAnalyticsTracking = () => {
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const isLoading = useSearchPageQueryIsLoading();
  const requestId = useSearchPageRequestId();
  const productSearchString = useSearchPageProductSearchString();
  const { pathname } = useLocation();
  const history = useHistory();
  const exactSearchReturnedNoResults =
    useSearchPageExactSearchReturnedNoResults();
  const filterKeys = useSearchPageFilters();

  const recordMilestoneOnce = useRecordMilestoneOnce();

  useEffect(() => {
    if (!isLoading) {
      // For narrow autocomplete filters, track whenever there are no AND results
      if (
        exactSearchReturnedNoResults &&
        filterKeys?.length === NUM_FILTERS_FOR_TRACKING
      ) {
        // Derive c2Category from filter_keys for tracking purposes
        const c2Category: string | undefined = filterKeys
          ?.filter(
            (category) =>
              category.includes(CATEGORY_FILTER_PREFIX) &&
              category.split(CATEGORY_PIPE).length === C2_NUM_CATEGORIES
          )[0]
          ?.replace(CATEGORY_FILTER_PREFIX, "")
          .trim();
        // Query resulted in no OR results
        if (c2Category !== undefined && requestId !== undefined) {
          trackSearchNarrowSearchEmptyAndResultsWithEmptyOrResultsView(
            productSearchString,
            c2Category,
            requestId
          );
        }
      }
    }
  }, [
    exactSearchReturnedNoResults,
    isLoading,
    productSearchString,
    requestId,
    isFromDiscoverURL,
    filterKeys,
  ]);

  useEffect(() => {
    recordMilestoneOnce(HAS_VISITED_CATEGORY_SEARCH_PAGES);
    recordLandingActivity(
      {
        search_term: productSearchString,
      },
      history
    );

    recordSignupActivity({ search_term: productSearchString }, pathname);
  }, [pathname, productSearchString, recordMilestoneOnce, history]);
};
